import {template} from 'lodash';
import {markdown} from "markdown"

const $programmCarouselTmpl = $('#programmCarouselTmpl');
const programmTmpl = template($programmCarouselTmpl.html());
let programmContext = window.programmContext;

/**
 * Sample context
 */
if (!programmContext) programmContext = {
  items: [
    {
      name: 'Акробатика',
      about: '',
      photo: './img/camp_summer-programm_1.png',
    },
    {
      name: 'Гимнастика',
      about: '',
      photo: './img/camp_summer-programm_2.png',
    },
    {
      name: 'Театр',
      about: '',
      photo: './img/camp_summer-programm_3.png',
    },
    {
      name: 'Творчество',
      about: '',
      photo: './img/camp_summer-programm_4.png',
    },
    {
      name: 'Подвижные игры',
      about: '',
      photo: './img/camp_summer-programm_5.png',
    }
  ]
};

programmContext.markdown = markdown;

 // console.log('programmContext: ',window.programmContext);

 // console.log(programmTmpl(programmContext));

if (programmContext) {
  $programmCarouselTmpl.replaceWith(programmTmpl(programmContext));
  initProgrammCarousel();
}

function initProgrammCarousel() {
  const $programmCarousel = $('#programmCarouselControls');
  const $carouselBtns = $('a[data-slide]');
  const $programmCounter = $('#programm-counter .programm-counter-current');

// Prevent page from scrolling
  $carouselBtns.click((e) => {
    e.preventDefault();
  });

  if ($programmCarousel) {
    const updateProgrammCounter = () => {
      const currentIndex = $programmCarousel.find('.carousel-item.active').index() + 1;
      const total = $programmCarousel.find('.carousel-item').length;
      $programmCounter.html(`${currentIndex}/${total}`);
      //$programmAbout.html(markdown.toHTML(programmContext.items[currentIndex - 1].about));
    };

    $programmCarousel.on('slid.bs.carousel', updateProgrammCounter);
    updateProgrammCounter()
  }

// Create infinite 3x carousel

  // const $programmCarousel = $('#programmCarouselControls');

  // $programmCarousel.find('.carousel-item').each(function () {
  //   let next = $(this).next();
  //   if (!next.length) {
  //     next = $(this).siblings(':first');
  //   }
  //   next.children(':first-child').clone().appendTo($(this));

  //   if (next.next().length > 0) {
  //     next.next().children(':first-child').clone().appendTo($(this));
  //   }
  //   else {
  //     $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
  //   }
  // });
}


// WEBPACK FOOTER //
// ./src/js/programm-carousel.js